import { useEffect, useState } from "react";

export default function useTailwindMd() {
  const query = "(min-width: 768px)";

  const [isMobile, setIsMobile] = useState(() =>
    window.matchMedia(query).matches
  );

  useEffect(() => {
    const media = window.matchMedia(query);

    const handler = (e) => setIsMobile(e.matches);

    // ✅ Modern browsers
    if (media.addEventListener) {
      media.addEventListener("change", handler);
    }
    // ✅ Safari fallback
    else {
      media.addListener(handler);
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener("change", handler);
      } else {
        media.removeListener(handler);
      }
    };
  }, []);

  return isMobile; // true === md and above
}